import { action } from 'mobx';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import EmployeesStore from 'stores/Employees/EmployeesStore';

import Button from 'components/Button/Button';
import Datepicker from 'components/Form/Fields/Datepicker/Datepicker';
import { bindFormControl } from 'components/Form/FormControl/FormControl';
import ActionSelect from 'components/ActionSelect/ActionSelect';
import SelectField from 'components/Form/Fields/Select/SelectField';

import style from './Employees.module.scss';

interface Props {
  store: EmployeesStore;
}

@observer
class EmployeesFormComponent extends Component<Props> {
  formControl = bindFormControl(this.props.store.form);

  options = [
    {
      title: 'title.excel',
      action: () => this.props.store.getAccountantExcelReport(),
    },
  ];

  @action.bound
  async fetchEmployees() {
    const form = this.props.store.form;

    if (form.isFormValid) {
      await this.props.store.fetchEmployees();
    }
  }

  render() {
    const { form } = this.props.store;
    const FormControl = this.formControl;

    return (
      <form className={style.form}>
        <div className={style.form__field}>
          <label className={style.form__label}>
            <FormattedMessage id="title.period" />
          </label>

          <FormControl
            name="period"
            render={props => (
              <Datepicker
                {...props}
                styles={{
                  calendar: style.datepicker,
                  button: style.datepicker__btn,
                }}
                value={form.period}
                selectRange
              />
            )}
          />
        </div>
        <div className={style.form__field}>
          <label className={style.form__label}>
            <FormattedMessage id="title.userGroups" />
          </label>

          <FormControl
            name="userGroupId"
            className={style.form__field}
            render={props => (
              <SelectField
                {...props}
                isLoading={form.loading}
                options={form.userGroupValues}
              />
            )}
          />
        </div>

        <Button
          className={style.button}
          onClick={this.fetchEmployees}
          disabled={!form.isFormValid}
        >
          <FormattedMessage id="button.generate.report" />
        </Button>

        <ActionSelect
          title="title.export.report"
          options={this.options}
          styles={{ buttonStyle: style.actionButton }}
        />
      </form>
    );
  }
}

export default EmployeesFormComponent;
